import { Tag } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const PlatformProfile2FATag = ({ isEnabled }: { isEnabled: boolean }) => {
    if (!isEnabled) {
        return (
            <Tag variant="mustard">
                <LocalizedText textKey={TextKey.UserSecurityStatusTagNotSecured} />
            </Tag>
        );
    }

    return (
        <Tag variant="lime">
            <LocalizedText textKey={TextKey.UserSecurityStatusTagMFA} />
        </Tag>
    );
};
